import { render, staticRenderFns } from "./ModalReprove.vue?vue&type=template&id=86a006f8&scoped=true&"
import script from "./ModalReprove.vue?vue&type=script&lang=ts&"
export * from "./ModalReprove.vue?vue&type=script&lang=ts&"
import style0 from "./ModalReprove.vue?vue&type=style&index=0&id=86a006f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a006f8",
  null
  
)

export default component.exports